import { apiClient } from "./client";
import type { AttendanceStatus } from "@/types/enums";

export interface AttendanceMatrixLesson {
  id: string;
  date: string;
  canceled: boolean;
  startAt: string | null;
  topic: string | null;
  presentCount: number;
  rosterSize: number;
  records: Record<string, { status: AttendanceStatus; grade: number | null; lockedBy: string | null }>;
}

export interface AttendanceMatrix {
  group: { id: string; code: string; subjectName: string };
  month: string;
  lessons: AttendanceMatrixLesson[];
  roster: { studentId: string; fullName: string; phone: string }[];
}

export async function fetchAttendanceMatrix(groupId: string, month: string): Promise<AttendanceMatrix> {
  const { data } = await apiClient.get<AttendanceMatrix>("/attendance/matrix", { params: { groupId, month } });
  return data;
}

export async function patchAttendanceCell(payload: { lessonId: string; studentId: string; status?: AttendanceStatus }): Promise<void> {
  await apiClient.patch("/attendance/cell", payload);
}

